export const HANDLED_RETURN_KEY = 'hyperswitch_return_handled';
